"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const query_string_1 = __importDefault(require("query-string"));
const loadRemoteScript_1 = __importDefault(require("./loadRemoteScript"));
var Library;
(function (Library) {
    Library["Drawing"] = "drawing";
    Library["Geometry"] = "geometry";
    Library["Places"] = "places";
    Library["Visualization"] = "visualization";
})(Library || (Library = {}));
function loadGoogleMapsApi({ googleApiKey, libraries = [], }) {
    const { google } = window;
    // If this load request doesn’t require any optional libraries, the existence
    // of the google.maps object inside the window object implies the library has
    // already loaded.
    const hasGoogleMapsLoaded = Boolean(google && google.maps);
    // Resolve if the Google Maps SDK is loaded, as well as all the other optional libraries
    if (hasGoogleMapsLoaded && libraries.every((library) => Boolean(google.maps[library]))) {
        return Promise.resolve();
    }
    const params = query_string_1.default.stringify({
        key: googleApiKey,
        libraries: libraries.length ? libraries.sort().join(',') : undefined,
    });
    return loadRemoteScript_1.default(`https://maps.googleapis.com/maps/api/js?${params}`);
}
exports.default = loadGoogleMapsApi;
